import { useState, useCallback } from "react";
import { apiCore } from "../api/apiCore";
import * as url from "../api/urls";

interface ChangePasswordRequest {
  oldPassword: string;
  password: string;
  confirmpassword: string;
}

export const useChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const changePassword = useCallback(async (data: ChangePasswordRequest) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      await apiCore(url.USER_CHANGE_PASSWORD, {
        method: "POST",
        body: data,
      });

      setSuccess(true);
    } catch (err: any) {
      setError(err?.toString() ?? "Erro ao alterar senha");
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    success,
    changePassword,
  };
};
